var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStatsArrowColored(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.90024 11.0441L13.5732 6.50409C13.6507 6.42952 13.7123 6.34081 13.7543 6.24306C13.7963 6.14532 13.8179 6.04048 13.8179 5.93459C13.8179 5.8287 13.7963 5.72386 13.7543 5.62611C13.7123 5.52837 13.6507 5.43965 13.5732 5.36509C13.4183 5.21569 13.2086 5.13184 12.9901 5.13184C12.7716 5.13184 12.562 5.21569 12.407 5.36509L8.27166 9.33556L4.17763 5.36508C4.02266 5.21569 3.81304 5.13184 3.59454 5.13184C3.37603 5.13184 3.16641 5.21569 3.01145 5.36508C2.9333 5.43937 2.87113 5.52796 2.82853 5.62572C2.78594 5.72348 2.76378 5.82846 2.76332 5.93459C2.76378 6.04071 2.78594 6.1457 2.82853 6.24345C2.87113 6.34121 2.9333 6.4298 3.01145 6.50409L7.68443 11.0441C7.76188 11.1255 7.85588 11.1905 7.96051 11.2349C8.06513 11.2793 8.17811 11.3023 8.29233 11.3023C8.40656 11.3023 8.51954 11.2793 8.62416 11.2349C8.72879 11.1905 8.82279 11.1255 8.90024 11.0441Z",
    fill: "#232360"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatsArrowColored);
export default __webpack_public_path__ + "static/media/stats_arrow_colored.3d3d62bb429eb839f787dd5f8727c827.svg";
export { ForwardRef as ReactComponent };